import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/电影" },
  { label: "电视剧", to: "/category/电视剧" },
  { label: "动漫", to: "/category/动漫" },
  { label: "搜索", to: "/search" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const isHome = location.pathname === "/";
  const overlay = isHome && !scrolled;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const linkBase = "relative px-3 py-2 text-sm font-medium whitespace-nowrap transition-colors";

  const brandInner = (
    <>
      <span className="flex items-center justify-center w-9 h-9 rounded-md bg-primary-500 text-background-50">
        <i className="ri-movie-2-fill text-lg" />
      </span>
      <span className={`font-heading text-lg font-bold tracking-tight ${overlay ? "text-background-50" : "text-foreground-950"}`}>
        芭乐视频
      </span>
    </>
  );

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        overlay ? "bg-transparent" : "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          {isHome ? (
            <h1 className="flex items-center gap-2.5 shrink-0 m-0">
              <Link to="/" className="flex items-center gap-2.5 cursor-pointer" aria-label="芭乐视频首页">
                {brandInner}
              </Link>
            </h1>
          ) : (
            <Link to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
              {brandInner}
            </Link>
          )}

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `${linkBase} ${
                    overlay
                      ? isActive
                        ? "text-primary-300"
                        : "text-background-100 hover:text-primary-300"
                      : isActive
                        ? "text-primary-600"
                        : "text-foreground-600 hover:text-primary-600"
                  }`
                }
                end={item.to === "/"}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-2">
            <Link
              to="/search"
              className={`flex items-center justify-center w-9 h-9 rounded-md transition-colors ${
                overlay ? "text-background-50 hover:bg-background-50/15" : "text-foreground-600 hover:bg-background-100"
              }`}
              aria-label="搜索"
            >
              <i className="ri-search-line" />
            </Link>
          </div>

          <button
            type="button"
            className={`md:hidden flex items-center justify-center w-10 h-10 rounded-md ${
              overlay ? "text-background-50" : "text-foreground-800"
            }`}
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="打开导航菜单"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 animate-soft-in">
          <nav className="flex flex-col px-4 py-3">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-md text-sm font-medium ${
                    isActive ? "bg-primary-50 text-primary-700" : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      ) : null}
    </header>
  );
}